import React from 'react';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import { BREAKPOINTS } from '../../../constants';
import { TRANSLATIONS } from '../../../translations';

const XmasContestModal = ({ isDeviceSmallerThanTablet }) => {
  const features = [
    {
      text: TRANSLATIONS.XMAS_FEATURE_1,
      icon: 'material-symbols:featured-seasonal-and-gifts-rounded',
    },
    {
      text: TRANSLATIONS.XMAS_FEATURE_2,
      svg: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 4.91406L5.91406 7H8V4.91406ZM18.9541 9.08887C18.9541 8.80013 18.8387 8.52272 18.6348 8.31836C18.5338 8.21698 18.4133 8.13598 18.2812 8.08105C18.1491 8.02616 18.0073 7.9971 17.8643 7.99707C17.7212 7.99707 17.5794 8.02617 17.4473 8.08105C17.3151 8.13596 17.1947 8.21599 17.0938 8.31738L16.7178 8.69336L18.2578 10.2334L18.6357 9.85742C18.8391 9.65323 18.954 9.3771 18.9541 9.08887ZM10.6602 14.75L10.2744 16.6748L12.2002 16.2891L16.8438 11.6475L15.3037 10.1064L10.6602 14.75ZM17 5V4H10V7C10 7.53043 9.78913 8.03899 9.41406 8.41406C9.03899 8.78913 8.53043 9 8 9H5V20H17V15C17 14.4477 17.4477 14 18 14C18.5523 14 19 14.4477 19 15V20C19 20.5304 18.7891 21.039 18.4141 21.4141C18.039 21.7891 17.5304 22 17 22H5C4.46957 22 3.96101 21.7891 3.58594 21.4141C3.21086 21.039 3 20.5304 3 20V7.91406C3.00011 7.38374 3.21093 6.87497 3.58594 6.5L7.5 2.58594L7.64648 2.45312C8.0023 2.1615 8.44998 2.0001 8.91406 2H17C17.5304 2 18.039 2.21086 18.4141 2.58594C18.7891 2.96101 19 3.46957 19 4V5C19 5.55228 18.5523 6 18 6C17.4477 6 17 5.55228 17 5ZM20.9541 9.08887C20.954 9.90727 20.629 10.6922 20.0508 11.2715L13.3994 17.918C13.26 18.0573 13.0829 18.1526 12.8896 18.1914L9.19629 18.9307C8.86844 18.9963 8.52941 18.8936 8.29297 18.6572C8.05656 18.4208 7.95396 18.0818 8.01953 17.7539L8.75879 14.0615L8.79785 13.9199C8.84749 13.7817 8.92754 13.6555 9.03223 13.5508L15.6777 6.90527C15.9643 6.61778 16.3048 6.38916 16.6797 6.2334C17.055 6.07748 17.4578 5.99707 17.8643 5.99707C18.2707 5.9971 18.6735 6.07744 19.0488 6.2334C19.4237 6.3892 19.7642 6.6177 20.0508 6.90527L20.1562 7.0166C20.6684 7.58319 20.9541 8.32152 20.9541 9.08887Z" fill="#181F36" />
        </svg>
      ),
    },
    {
      text: TRANSLATIONS.XMAS_FEATURE_3,
      icon: 'material-symbols:celebration-outline-rounded',
    },
  ];

  return (
    <div className="xmas-contest-modal">
      <style>
        {`
                .xmas-contest-modal__image-wrapper {
                  position: relative;
                  overflow: hidden;
                  border-radius: 8px 0 0 8px;
                }
                .xmas-contest-modal__image {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
                .xmas-contest-modal__svg {
                  position: absolute;
                  display: block;
                  right: -3px;
                  top: 0;
                  bottom: auto;
                  height: 100%;
                  width: auto;
                  transform: none;
                }
                .xmas-contest-modal__text-content {
                  padding: 0;
                  border-radius: 0 8px 8px 0;
                  text-align: left;
                }
                @media (min-width: 768px) {
                  .xmas-contest-modal__text-content {
                    padding: 2rem;
                  }
                }
                @media (max-width: 768px) {
                  .xmas-contest-modal__text-content {
                    border-radius: 8px;
                  }
                }
                .xmas-contest-modal__content {
                  display: flex;
                  flex-direction: column;
                }
                @media (min-width: 768px) {
                  .xmas-contest-modal__content {
                    flex-direction: row;
                    max-width: 900px;
                  }
                  .xmas-contest-modal__image-wrapper {
                    flex: 0 0 50%;
                  }
                  .xmas-contest-modal__text-content {
                    flex: 1;
                  }
                }
                .xmas-contest-modal__feature {
                  display: flex;
                  align-items: flex-start;
                  gap: 0.75rem;
                  margin-bottom: 1rem;
                }
                .xmas-contest-modal__feature-icon {
                  flex-shrink: 0;
                  width: 24px;
                  height: 24px;
                }
                .xmas-contest-modal__feature-text {
                  flex: 1;
                  font-size: 16px;
                  line-height: 1.5;
                }
                @media (min-width: 768px) {
                  .xmas-contest-modal__feature-text {
                    font-size: 14px;
                  }
                }
                .xmas-contest-modal__text-content h4 {
                  font-size: 18px;
                }
                @media (min-width: 768px) {
                  .xmas-contest-modal__text-content h4 {
                    font-size: 1rem;
                  }
                }
              `}
      </style>
      <div className="xmas-contest-modal__content">
        {!isDeviceSmallerThanTablet && (
          <div className="xmas-contest-modal__image-wrapper">
            <img
              className="xmas-contest-modal__image"
              src="https://cdn.freedome.it/images/xmas/2025/hero-def-natale.jpg"
              alt="Xmas Contest"
              loading="lazy"
            />
            <svg
              className="xmas-contest-modal__svg"
              viewBox="0 0 41 301"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
            >
              <path
                d="M24.1898 61.7195C18.9787 91.9195 11.378 121.725 0 150.131C11.4649 178.406 18.9787 208.212 24.1898 238.324C27.7946 259.027 30.3133 279.991 31.6587 301L41 301L41 -1.00001L31.6587 -0.999805C30.3118 20.0088 27.7931 40.9736 24.1883 61.7195H24.1898Z"
                fill="#ffffff"
              />
            </svg>
          </div>
        )}
        <div className="xmas-contest-modal__text-content">
          <h4>
            {TRANSLATIONS.XMAS_MODAL_TITLE}
          </h4>
          <div>
            {features.map((feature, index) => (
              <div key={index} className="xmas-contest-modal__feature">
                <div className="xmas-contest-modal__feature-icon">
                  {feature.svg ? (
                    feature.svg
                  ) : (
                    <span className="iconify" data-icon={feature.icon} data-width="24" data-height="24"></span>
                  )}
                </div>
                <div className="xmas-contest-modal__feature-text">
                  {feature.text}
                </div>
              </div>
            ))}
          </div>
          <p style={{ fontSize: '12px', marginTop: '1rem', marginBottom: '0' }}>
            Tutti i dettagli della promozione nella{' '}
            <a
              href={TRANSLATIONS.BLACK_FRIDAY_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}
            >
              pagina del concorso
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default XmasContestModal;
